<template>
  <div class="video-stage" :class="{ 'video-stage-compact': compact }">

    <div v-if="ceremonyVideoLoading" class="video-player-shell">
      <div class="video-player-copy">
        <span class="eyebrow">Loading video</span>
        <h3>Loading configured video</h3>
        <p>Loading the ceremony video into the player...</p>
      </div>
    </div>

    <div v-else-if="ceremonyVideoError" class="video-player-shell">
      <div class="video-player-copy">
        <span class="eyebrow">Video unavailable</span>
        <h3>Could not load ceremony video</h3>
        <p>{{ ceremonyVideoError }}</p>
      </div>
    </div>

    <video-player
      v-else-if="activeVideoUrl"
      ref="videoPlayer"
      :key="activeVideoUrl"
      class="ceremony-video-player"
      :options="videoOptions"
      @loadeddata="$emit('loadeddata')"
    ></video-player>

    <div v-else class="video-player-shell">
      <div class="video-player-copy">
        <span class="eyebrow">Video player</span>
        <h3>Please select a ceremony</h3>
        <p>Set the ceremony you would like to search and then enter your query. Click search to begin ceremony intelligence.</p>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../plugins/video-player'

export default {
  name: 'CeremonyMediaPlayer',
  props: {
    activeVideoUrl: {
      type: String,
      default: '',
    },
    ceremonyVideoLoading: {
      type: Boolean,
      default: false,
    },
    ceremonyVideoError: {
      type: String,
      default: '',
    },
    videoOptions: {
      type: Object,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    player() {
      return this.$refs.videoPlayer?.player || null
    },
  },
}
</script>

<style scoped>
.video-stage {
  margin-bottom: 20px;
}

.video-stage-compact {
  max-width: 880px;
  margin: 0 auto 20px;
}

.video-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.video-toolbar-note {
  font-size: 0.85rem;
  color: #475569;
}

.video-player-shell {
  min-height: 360px;
  border: 1px solid #d6dbe5;
  background:
    radial-gradient(circle at top left, rgba(59, 130, 246, 0.14), transparent 30%),
    radial-gradient(circle at bottom right, rgba(16, 185, 129, 0.12), transparent 28%),
    linear-gradient(135deg, #f8fafc 0%, #eef2f7 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.ceremony-video-player {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border: 1px solid #d6dbe5;
  background: #000;
  border-radius: .25rem;
}

.video-stage-compact .ceremony-video-player,
.video-stage-compact .video-player-shell {
  max-width: 880px;
  margin-inline: auto;
}

.ceremony-video-player :deep(.video-js) {
  width: 100% !important;
  height: 100% !important;
  min-height: 0;
  padding-top: 0 !important;
}

.ceremony-video-player :deep(.video-js video) {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.video-player-copy {
  text-align: center;
  max-width: 420px;
}

.video-player-copy h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #0f172a;
  margin: 10px 0 8px;
}

.video-player-copy p {
  color: #475569;
  line-height: 1.6;
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(148, 163, 184, 0.5);
  padding: 6px 12px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #334155;
}
</style>
